import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=79af1219&"
import script from "./Frequency.vue?vue&type=script&lang=js&"
export * from "./Frequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports